import { render } from "./realisasi_anggaran_2024.vue?vue&type=template&id=77362852&scoped=true"
import script from "./realisasi_anggaran_2024.vue?vue&type=script&lang=js"
export * from "./realisasi_anggaran_2024.vue?vue&type=script&lang=js"

import "./realisasi_anggaran_2024.vue?vue&type=style&index=0&id=77362852&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77362852"]])

export default __exports__